import script from "./buyIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./buyIndex.vue?vue&type=script&setup=true&lang=js"

import "./buyIndex.vue?vue&type=style&index=0&id=6c983d24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c983d24"]])

export default __exports__